module.exports = __webpack_public_path__ + "assets/Spacing selected.f308d241dbdbc70e269d252f5456db1c.png";